import { Group, Intersection, XRControllerEventType as ThreeXRControllerEventType } from 'three';
import {useFrame} from "@react-three/fiber";
import {useEffect, useRef} from "react";
import * as THREE from "three";
import {useXR, Interactive, useXRInputSourceState, XRControllerState} from "@react-three/xr";
import {Raycaster, Vector3} from "three";

export function useXREvent_fixed(
	type: Exclude<ThreeXRControllerEventType, XRSessionEventType | 'connected' | 'disconnected'>,
	handler: (event: {
	  type: Exclude<ThreeXRControllerEventType, XRSessionEventType | 'connected' | 'disconnected'>
	  data: XRInputSource
	}) => void,
	{ handedness }: { handedness?: XRHandedness } = {},
 ) {
	const session = useXR((xr) => xr.session)
	const handlerRef = useRef(handler)
	handlerRef.current = handler
	useEffect(() => {
	  if (session == null) {
		 return
	  }
	  const fn = (e: XRInputSourceEvent) => {
		 handlerRef.current?.({
			type: e.type,
			data: e.inputSource,
		 })
	  }
	  session.addEventListener(type, fn)
	  return ()=>session.removeEventListener(type, fn)
	}, [session, handedness, type])
 }

// export function useFrame_gettingControllerTarget(controller: XRControllerState) {
// 	// Create refs for raycaster and temporary vector
// 	const raycaster = useRef(new Raycaster());
// 	const direction = useRef(new Vector3());
// 	const origin = useRef(new Vector3());
// 	const pointedLocation = useRef(new Vector3());

// 	// Optional: objects to test intersection with
// 	//const objectsRef = useRef([]);

// 	useFrame(() => {
// 		if (controller.object) {
// 			// Get controller position as ray origin
// 			controller.object.getWorldPosition(origin.current);

// 			// Get the direction the controller is pointing
// 			direction.current.set(0, 0, -1);
// 			direction.current.applyQuaternion(controller.object.quaternion);

// 			// Set up and cast the ray
// 			raycaster.current.set(origin.current, direction.current);

// 			// Option 1: Find a specific distance the controller is pointing at
// 			pointedLocation.current.copy(origin.current).add(
// 				direction.current.clone().multiplyScalar(5) // 5 meters away
// 			);

// 			// Option 2: Test against specific objects
// 			// const intersections = raycaster.current.intersectObjects(objectsRef.current)
// 			// if (intersections.length > 0) {
// 			//   pointedLocation.current.copy(intersections[0].point)
// 			// }

// 			console.log('Controller pointing at:', pointedLocation.current);
// 		}
// 	})
// }